import { db, firestorage } from "../Config";

export const getEmpresaById = (empresaId) => {
  let empresaRef = db.collection("empresas").doc(empresaId);
  return new Promise((resolve, reject) => {
    let empresa = {};
    empresaRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          empresa = doc.data();
          resolve(empresa);
        } else {
          reject("no encontro la empresa");
        }
      })
      .catch((err) => {
        reject(err.message);
      });
  });
};


/**
 * Funcion que registra un pago de membresia en estado pendiente
 * @param {string} empresaId - ID de la empresa.
 * @param {object} pago - Objeto con los detalles del pago (monto, fecha, medio, comprobante, etc.).
 * @returns {Promise<object>} - Objeto con el resultado de la operación.
 */
export const registrarPagoMembresia = async (empresaId, pago) => {
  try {
    const empresaRef = db.collection('empresas').doc(empresaId);
    const pagosRef = empresaRef.collection('pagos');

    // Añadir el pago a la subcolección 'pagos'
    await pagosRef.add(pago);

    
// 4. Actualizar la empresa con la nueva fecha de vencimiento y el tipo de membresía
    await empresaRef.update({
      estado: 'PENDIENTE'
    });

    return { success: true, message: 'Pago registrado con éxito. Pendiente de confirmación.' };
  } catch (error) {
    console.error('Error al registrar el pago de membresía:', error);
    throw error;
  }
};



/**
 * Funcion que realiza el confirma el pago, cambia el estado del pago y amplia el plazo de vencimiento de la empresa
 *  
 */
export const confirmarPagoMembresia = async (empresaId, pagoId, plan, duracionMeses = 1) => {
  try {
    const empresaRef = db.collection('empresas').doc(empresaId);
    const pagoRef = empresaRef.collection('pagos').doc(pagoId);

    // 1. Actualizar el estado del pago a 'confirmado'
    await pagoRef.update({ estado: 'confirmado' });

    // 2. Obtener la fecha de vencimiento actual de la empresa
    const empresaDoc = await empresaRef.get();
    if (!empresaDoc.exists) {
      throw new Error('Empresa no encontrada.');
    }
    const empresaData = empresaDoc.data();
    const fecVenActual = empresaData.fecVen
      ? (typeof empresaData.fecVen.toDate === 'function' ? empresaData.fecVen.toDate() : new Date(empresaData.fecVen))
      : new Date();

    // 3. Calcular la nueva fecha de vencimiento
    const nuevaFecVen = new Date(fecVenActual);
    nuevaFecVen.setMonth(nuevaFecVen.getMonth() + duracionMeses);

    // 4. Actualizar la empresa con la nueva fecha de vencimiento y el tipo de membresía
    const resolvedPlan = (plan || 'basic').toLowerCase();
    const existingSubscription = empresaData.subscription || {};

    await empresaRef.update({
      fecUltPago: new Date(), // O la fecha de confirmación del pago si es diferente
      fecVen: nuevaFecVen,
      tipoMembresia: plan.toUpperCase(),
      estado: 'ACTIVO',
      plan: resolvedPlan,
      subscription: {
        status: 'active',
        trialStart: existingSubscription.trialStart || empresaData.fecIni || new Date(),
        trialEnd: existingSubscription.trialEnd || new Date()
      },
      usage: {
        whatsappMessagesSent: 0
      }
    });

    return { success: true, message: 'Pago confirmado y membresía actualizada.' };
  } catch (error) {
    console.error('Error al confirmar el pago de membresía:', error);
    throw error;
  }
};





  



export const getEmpresas = () => {
  return new Promise((resolve, reject) => {
    let empresas = [];

    let empresasRef = db.collection("empresas");
    empresasRef
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          empresas.push(doc.data());
        });
        resolve(empresas);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const saveEmpresa = (emp) => {
  return new Promise((resolve, reject) => {
    const empRef = db.collection("empresas").doc(emp.id);

    empRef
      .set(emp)
      .then((docRef) => {
        resolve(true);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addEmpresa = (emp) => {
  return new Promise((resolve, reject) => {
    const empRef = db.collection("empresas").doc();
    emp.id = empRef.id;
    empRef
      .set(emp)
      .then(() => {
        resolve(emp);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const uploadImage = async (file) => {
  const storageRef = firestorage.ref();
  let pathFile = `logos/${file.name}`;
  const fileRef = storageRef.child(pathFile);
  await fileRef.put(file);
  const fileUrl = await fileRef.getDownloadURL();
  return fileUrl;
};
